const routers = [
    {
        path: '/personal_center/account_settings',
        name: 'account_settings',
        meta: {
            exp: '账户设置',
            requireAuth: true
        },
        redirect: '/personal_center/account_settings/base_info',
        component: () => import('@/views/personal_center/account_settings/index.vue'),
        children: [
            {
                path: '/personal_center/account_settings/base_info',
                name: 'account_settings',
                meta: {
                    exp: '账户绑定(默认基本信息)',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/essential_information/index.vue')
            },
            {
                path: '/personal_center/account_settings/essential_information',
                name: 'essential_information',
                meta: {
                    exp: '基本信息',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/essential_information/index.vue')
            },
            {
                path: '/personal_center/account_settings/change_password',
                name: 'change_password',
                meta: {
                    exp: '修改密码',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/change_password/index.vue')
            },
            {
                path: '/personal_center/account_settings/mobile_phone_binding',
                name: 'mobile_phone_binding',
                meta: {
                    exp: '手机绑定',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/mobile_phone_binding/index.vue')
            },
            {
                path: '/personal_center/account_settings/mail_binding',
                name: 'mail_binding',
                meta: {
                    exp: '邮箱绑定',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/mail_binding/index.vue')
            },
            {
                path: '/personal_center/account_settings/QQ_binding',
                name: 'QQ_binding',
                meta: {
                    exp: 'QQ绑定',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/QQ_binding/index.vue')
            },
            {
                path: '/personal_center/account_settings/WX_binding',
                name: 'WX_binding',
                meta: {
                    exp: '微信绑定',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/WX_binding/index.vue')
            },
            {
                path: '/personal_center/account_settings/WB_binding',
                name: 'WB_binding',
                meta: {
                    exp: '微博绑定',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/WB_binding/index.vue')
            },
            {
                path: '/personal_center/account_settings/WX_bindingLogin',
                name: 'WX_bindingLogin',
                meta: {
                    exp: '微信绑定Login',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/WX_binding/wx_login.vue')
            },
            {
                path: '/personal_center/account_settings/changeEnterprise',
                name: 'changeEnterprise',
                meta: {
                    exp: '企业切换',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/account_settings/changeEnterprise/index.vue')
            }
        ]
    },
];
export default routers